import { type CatalogAccessSettings } from '@webapp/modules/purchasing/entities/CatalogAccessSettings'
import { useGetCatalogAccessSettingsModel } from '../../models/useGetCatalogAccessSettingsModel'

export interface UseGetCatalogAccessSettingsPresenterReturn {
  data: {
    settings: CatalogAccessSettings | undefined
  }
  states: {
    isLoading: boolean
    isError: boolean
  }
}

export const useGetCatalogAccessSettingsPresenter =
  (): UseGetCatalogAccessSettingsPresenterReturn => {
    const {
      data: settings,
      isLoading,
      error,
    } = useGetCatalogAccessSettingsModel()

    return {
      data: {
        settings,
      },
      states: {
        isLoading,
        isError: error !== null,
      },
    }
  }
